import {Navigate} from "react-router-dom";

export function RouterError() {
    return <Navigate to="/" replace />;
}
